var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-layer",attrs:{"id":_vm._uid + '-widget-layer'}},[_c('object',{staticClass:"widget-iframe",attrs:{"id":_vm._uid + '-widget-iframe',"data":_vm.widgetHtml}})])}
var staticRenderFns = []

export { render, staticRenderFns }